module.exports = __webpack_public_path__ + "img/torax.04d30dd6.png";